module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("e5A4A"))).then(() => module.bundle.root('hEqeo'));